import type { ProjectContent, ProjectContentCategory } from '@services/dto/content';
import type { DisciplineKey } from '@services/dto/projectShare';

export type ProjectContentEx = ProjectContent & {
  discipline?: DisciplineKey;
  disciplineById?: string;
  classification?: DisciplineKey;
  score?: number;
  parent?: ProjectContentEx;
  children: ProjectContentEx[];
  images?: {
    full?: string;
    card?: string;
    thumb?: string;
  };
  pageIndex?: number;
};

export type ProjectFilesState = {
  loading: boolean;
  files: ProjectContentEx[];

  category?: ProjectContentCategory | ProjectContentCategory[];
  categoryFiles: ProjectContentEx[];

  // biome-ignore lint/suspicious/noExplicitAny: Loose type.
  error?: any;
};
